import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        console.error('Error caught by boundary:', error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div style={{
                    padding: '20px',
                    textAlign: 'center',
                    marginTop: '50px'
                }}>
                    <h2>Something went wrong</h2>
                    <p>We're sorry, but there was an error loading this component.</p>
                    <button
                        onClick={() => {
                            this.setState({ hasError: false });
                            if (this.props.onReset) {
                                this.props.onReset();
                            }
                        }}
                        style={{
                            padding: '10px 20px',
                            marginTop: '20px',
                            cursor: 'pointer'
                        }}
                    >
                        Try Again
                    </button>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;